'use client';

import { useEffect, useState } from 'react';

import {
  UTMParams,
  initializeUTMParams,
  getSavedUTMParams,
} from '../utils/utmParams';

export const useUTMParams = () => {
  const [utmParams, setUtmParams] = useState<UTMParams>({});
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const params = initializeUTMParams();

    setUtmParams(params);
    setIsLoaded(true);
  }, []);

  const getUTMParams = (): UTMParams => {
    return getSavedUTMParams();
  };

  return {
    utmParams,
    isLoaded,
    getUTMParams,
  };
};
